import request from "superagent";

import config from "config/config";
import { getTabToken } from "common/MetaActions";
import { Entry } from "models/inventory/inventory";

export class InventoryAPI {
  static async getArticleRegister() {
    const response = await request
      .get(config.api.inventory.articleRegister.get)
      .set("Authorization", `Bearer ${getTabToken()}`);

    return response.body;
  }

  static async getFiscalYear(customerId: string) {
    const response = await request
      .get(config.api.fiscalyear.get(customerId))
      .set("Authorization", `Bearer ${getTabToken()}`);

    return response.body;
  }

  static async getInventories(customerId: string) {
    const response = await request
      .get(config.api.inventory.inventories.get(customerId))
      .set("Authorization", `Bearer ${getTabToken()}`);

    return response.body;
  }

  static async getInventory(customerId: string, inventoryId: number) {
    const response = await request
      .get(config.api.inventory.inventory.get(customerId, inventoryId))
      .set("Authorization", `Bearer ${getTabToken()}`);

    return response.body;
  }

  static async createInventory(customerId: string, perDate: string) {
    return await request
      .post(config.api.inventory.inventory.create(customerId))
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send({
        customer_id: customerId,
        per_date: perDate,
        state_name: "created"
      });
  }

  static async createInventoryPdf(
    customerId: string,
    inventoryId: number,
    companyName: string,
    username: string
  ) {
    const response = await request
      .post(config.api.inventory.inventory.createPdf(customerId, inventoryId))
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send({
        company_name: companyName,
        username: username
      });

    return response.body;
  }

  static async updateInventory(
    customerId: string,
    inventoryId: number,
    inventoryEntries: Entry[],
    state: string
  ) {
    return await request
      .put(config.api.inventory.inventory.update(customerId, inventoryId))
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send({
        id: inventoryId,
        customer_id: customerId,
        state_name: state,
        entries: inventoryEntries
      });
  }

  static async updateInventoryState(
    customerId: string,
    inventoryId: number,
    state: string
  ) {
    return await request
      .patch(config.api.inventory.inventory.update(customerId, inventoryId))
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send({
        id: inventoryId,
        state_name: state
      });
  }
}
